const safeArea = {
  state: {
    statusBarHeight: 0,
    osName: '',
  },

  mutations: {
    SET_SAFE_AREA(state, payload) {
      state.statusBarHeight = payload.statusBarHeight;
      uni.setStorageSync('statusBarHeight', payload.statusBarHeight);
    },
    SET_OS_NAME(state, payload) {
      state.osName = payload.osName;
    },
  },

  actions: {
    initSafeArea({ commit }) {
      // 获取系统信息
      const systemInfo = uni.getSystemInfoSync();
      // 基础状态栏高度
      const statusBarHeight = systemInfo.statusBarHeight || 0;
      const osName = systemInfo.osName || '';
      commit('SET_SAFE_AREA', {
        statusBarHeight,
      });
      commit('SET_OS_NAME', {
        osName,
      });
    },
  },
};

export default safeArea;
